/**
 * Index template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from "./lib/global";
import Logger from "./lib/logger";
import productSlider from "./lib/product-slider";
import reviewsSlider from "./lib/global-reviews-slider";
import audioMeditations from "./lib/global-audios";
import stepsSlider from "./lib/global-steps-slider";
import VideoBlock from "./lib/global-video-block";
import Location from "./lib/location";

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = "Product";

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	productSlider();
	reviewsSlider();
	audioMeditations();
	stepsSlider();
	numberObserver();
	VideoBlock();
	Location.checkCountry();
};

const countAnimation = () => {
	const animationDuration = 2000;
	const frameDuration = 1000 / 60;
	const totalFrames = Math.round(animationDuration / frameDuration);
	const easeOutQuad = (t) => t * (2 - t);

	const animateCountUp = (el) => {
		let frame = 0;
		const countTo = parseInt(el.innerHTML, 10);
		const counter = setInterval(() => {
			frame++;
			const progress = easeOutQuad(frame / totalFrames);
			const currentCount = Math.round(countTo * progress);

			if (parseInt(el.innerHTML, 10) !== currentCount) {
				el.innerHTML = commaSeparateNumber(Math.floor(currentCount));
			}

			if (frame === totalFrames) {
				clearInterval(counter);
			}
		}, frameDuration);
	};

	const commaSeparateNumber = (val) => {
		while (/(\d+)(\d{3})/.test(val.toString())) {
			val = val.toString().replace(/(\d+)(\d{3})/, "$1" + "," + "$2");
		}
		return val;
	};

	const runAnimations = () => {
		const countupEls = document.querySelectorAll(
			".global-num-sessions__num-number"
		);
		countupEls.forEach(animateCountUp);
	};

	runAnimations();
};

const numberObserver = () => {
	const target = document.querySelector(".global-num-sessions__num-number");
	let ran = false;

	if (target) {
		function handleIntersection(entries) {
			entries.map((entry) => {
				if (entry.isIntersecting) {
					if (ran == false) {
						countAnimation();
						ran = true;
					}
				}
			});
		}
	
		const observer = new IntersectionObserver(handleIntersection);
		observer.observe(target);
	}
};

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
